import { AddIcon, LinkIcon } from "@chakra-ui/icons";
import { Box, Text, List, ListItem, Tooltip, ListIcon, Link, Divider, Flex, Icon } from "@chakra-ui/react";
import ProductSellingPriceModal from "../ProductSellingPriceModal";
import { useState, useEffect } from "react";
import { getAxiosInstance } from "../../../utils/axiosInstance";
import { useTranslation } from "react-i18next";
import { SellingHistoryPrice } from "../product.type";

const ProductSellingPrice = (props: { productId: string | undefined }) => {
    const [editPrice, setEditPrice] = useState<boolean>(false);
    const [sellingHistoryPrice, setSellingHistoryPrice] = useState<SellingHistoryPrice>();

    const { t } = useTranslation("translations");

    const fetchData = async () => {
        try {
            const req = await getAxiosInstance().get(`/ProductPriceHistory/${props.productId}`);
            setSellingHistoryPrice(req.data);
        } catch (error) {
        }
    }

    useEffect(() => {
        fetchData();
    }, [editPrice])

    return (
        <>
            <Box className="mt-0 xl:mt-16 mb-2 w-[100%] md:w-[45%]">
                <Tooltip label={t("Click to Edit Product Price!")} aria-label='A tooltip' placement='top-start'>
                    <Text
                        onClick={() => setEditPrice(true)}
                        fontSize={{ base: '16px', lg: '18px' }}
                        color={'teal'}
                        fontWeight={'500'}
                        textTransform={'uppercase'}
                        mt='3rem'>
                        {t("Selling Price")}
                    </Text>
                </Tooltip>
                <Divider opacity={4} mb={'4'} />
                {
                    sellingHistoryPrice ?
                        <div className="w-full">
                            <List spacing={2}>
                                <ListItem>
                                    <Text as={'span'} fontWeight={'bold'} className="mr-2">
                                        {t("Value")}:
                                    </Text>
                                    {sellingHistoryPrice?.price ? sellingHistoryPrice.price.value : ""}
                                </ListItem>
                                <ListItem>
                                    <Text as={'span'} fontWeight={'bold'}>
                                        {t("Reference")}:
                                    </Text>
                                </ListItem>
                                <List spacing={3} ml={3}>
                                    {
                                        sellingHistoryPrice?.priceReference && sellingHistoryPrice.priceReference.map((c: any, index: number) => {
                                            return (
                                                <ListItem key={`link_${index}`}>
                                                    <ListIcon as={LinkIcon} color='green.500' />
                                                    <Link href={`${c.links}`} isExternal className="max-w-[300px] text-nowrap text-ellipsis ...">
                                                        {c.links}
                                                    </Link>
                                                </ListItem>
                                            )
                                        })
                                    }
                                </List>
                            </List>

                        </div> :
                        <>
                            <Flex dir="col" onClick={(e) => { setEditPrice(true) }}>
                                <Tooltip label={t("Add selling price")}>
                                    <div className="bg-gray-100 rounded p-10">
                                        <Icon

                                            onClick={() => { }}
                                            as={AddIcon}
                                            boxSize={30}
                                            color='gray.500'
                                        />
                                    </div>
                                </Tooltip>
                            </Flex>
                        </>
                }

            </Box>
            <ProductSellingPriceModal
                onClose={() => { setEditPrice(false) }}
                isOpen={editPrice}
                sellingHistoryPrice={sellingHistoryPrice ?? null}
                productId={props.productId}
            />

        </>
    )
}

export default ProductSellingPrice;